import Vue from 'vue'
import Router from 'vue-router'
// 登录页面
const Login = () =>
    import('../pages/login.vue')
// 第三方登录页面
const loginThirdParty = () =>
    import('../pages/loginThirdParty.vue')
const Page = () =>
    import('../pages/page.vue')
// 员工首页
const home = () =>
    import('../pages/home/home.vue')
// 市场部首页
const homePage = () =>
    import('../pages/homePage/homePage.vue')
// 个人线索数据
const personClueData = () =>
    import('../pages/homePage/personClueData.vue')
//线索查看页面
const clueView = () =>
    import('../pages/clueView/clueView.vue')
//市场部创建合同页面
const marketCreateContract = () =>
    import('../pages/marketCreateContract/marketCreateContract.vue')
//市场部查看合同页面
const marketViewContract = () =>
    import('../pages/marketViewContract/marketViewContract.vue')



//市场部全部项目页面
const marketAllproject = () =>
    import('../pages/marketAllproject/marketAllproject.vue')
//项目详情
const viewProject = () =>
    import('../pages/marketAllproject/viewProject.vue')
//市场部待签约项目页面
const marketTBSignedproject = () =>
    import('../pages/marketTBSignedproject/marketTBSignedproject.vue')
//市场部已到期项目页面
const marketExpireproject = () =>
    import('../pages/marketExpireproject/marketExpireproject.vue')
//财务部财务数据 列表页
const financialDataListM = () =>
    import('../pages/financialDataListM/financialDataListM.vue')
//市场部财务数据 列表页
const financialDataListF = () =>
    import('../pages/financialDataListF/financialDataListF.vue')
//财务数据 详情页
const financialDataDetails = () =>
    import('../pages/financialDataDetails/financialDataDetails.vue')
//市场部编辑页面
const financialDataEditM = () =>
    import('../pages/financialDataEditM/financialDataEditM.vue')
//财务部编辑页面
const financialDataEditF = () =>
    import('../pages/financialDataEditF/financialDataEditF.vue')
//执行中项目页面
const inExecutionProject = () =>
    import('../pages/inExecutionProject/inExecutionProject.vue')

//商务部全部项目页面
const businessAllproject = () =>
    import('../pages/businessAllproject/businessAllproject.vue')
//商务部待签约项目页面
const businessTBSignedproject = () =>
    import('../pages/businessTBSignedproject/businessTBSignedproject.vue')
//商务部已到期项目页面
const businessExpireproject = () =>
    import('../pages/businessExpireproject/businessExpireproject.vue')



//商务部查看合同页面
const businessViewContract = () =>
    import('../pages/businessViewContract/businessViewContract.vue')
//商务部接收合同页面
const businessReceiveContract = () =>
    import('../pages/businessReceiveContract/businessReceiveContract.vue')
//商务部维护互通页面
const businessMaintainContract = () =>
    import('../pages/businessMaintainContract/businessMaintainContract.vue')
//新增线索页
const addClue = () =>
    import('../pages/clueView/components/addClue.vue')
//创建关联合同
const addContract = () =>
    import('../pages/marketCreateContract/components/addContract.vue')
//创建合同
const createdRelatednessContract = () =>
    import('../pages/marketViewContract/components/createdRelatednessContract.vue')
//延期合同
const dealExpireContract = () =>
    import('../pages/marketExpireproject/components/dealExpireContract.vue')
//维护合同
const maintainContract = () =>
    import('../pages/businessMaintainContract/components/maintainContract.vue')
//接收合同页面
const receiveContract = () =>
    import('../pages/businessReceiveContract/components/receiveContract.vue')
//市场部查看合同页面详情页面
const viewContract = () =>
    import('../pages/marketViewContract/components/viewContract.vue')
//线索更新页面
const clueUpdate = () =>
    import('../pages/clueUpdate/clueUpdate.vue')
//我的关注
const myConcern = () =>
    import('../pages/myConcern/myConcern.vue')
//账号管理
const accountManage = () =>
    import('../pages/accountManage/accountManage.vue')
//部门管理
const departmentManage = () =>
    import('../pages/departmentManage/departmentManage.vue')
//线索详情
const clueViewDetail = () =>
    import('../pages/clueViewDetail/clueViewDetail.vue')
//线索修改
const clueViewUpdate = () =>
    import('../pages/clueViewUpdate/clueViewUpdate.vue')
//线索初评编辑页面
const deitOne = () =>
    import('../pages/clueUpdate/deitOne.vue')
//线索待审批审核详情页面（待初评）
const examineDetail = () =>
    import('../pages/clueUpdate/examineDetail.vue')
//线索待审批审核详情页面（待立项）
const examineDetail2 = () =>
    import('../pages/clueUpdate/examineDetail2.vue')
//线索报名编辑页面
const deitTwo = () =>
    import('../pages/clueUpdate/deitTwo.vue')
//线索报告结果录入编辑页面
const deitThree = () =>
    import('../pages/clueUpdate/deitThree.vue')
//线索立项评估编辑页面
const deitFour = () =>
    import('../pages/clueUpdate/deitFour.vue')
//标书制作编辑页面
const deitFive = () =>
    import('../pages/clueUpdate/deitFive.vue')
//文件存档编辑页面
const deitSix = () =>
    import('../pages/clueUpdate/deitSix.vue')
//项目结果录入编辑页面
const deitSeven = () =>
    import('../pages/clueUpdate/deitSeven.vue')
//商务支持部其他成员 线索更新页面
const swOtherUpdate = () =>
    import('../pages/swOtherUpdate/swOtherUpdate.vue')
//财务部 商品部 分公司管理中心 线索更新页面
const clueUpdateT = () =>
    import('../pages/clueUpdateT/clueUpdateT.vue')
//商务支持部主管 线索更新页面
const swDirectorUpdate = () =>
    import('../pages/swDirectorUpdate/swDirectorUpdate.vue')
//市场部其他成员 线索更新页面
const mOtherUpdate = () =>
    import('../pages/mOtherUpdate/mOtherUpdate.vue')

//客户管理模快
// 客户
const customer = () =>
    import('../pages/customerManage/customer.vue')
// 客户-编辑
const customerEditPage = () =>
    import('../pages/customerManage/customerEditPage.vue')
// 客户-查看
const viewCustomer = () =>
    import('../pages/customerManage/viewCustomer.vue')
// 联系人
const contacts = () =>
    import('../pages/customerManage/contacts.vue')
// 联系人编辑
const contactEditor = () =>
    import('../pages/customerManage/components/contactEditor.vue')
// 任务
const task = () =>
    import('../pages/customerManage/task.vue')

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [
        {
            path: '/',
            component: Page,
            children: [
                {
                    path: '',
                    redirect: {
                        name: 'login'
                    }
                },
                {
                    path: 'home',
                    name: 'home',
                    component: home,
                },
                {
                    path: 'homePage',
                    name: 'homePage',
                    component: homePage,
                },
                {
                    path: 'homePage/personClueData',
                    name: 'personClueData',
                    component: personClueData,
                },
                {
                    path: 'clueView',
                    name: 'clueView',
                    component: clueView,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: 'marketCreateContract',
                    name: 'marketCreateContract',
                    component: marketCreateContract,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: 'businessViewContract',
                    name: 'businessViewContract',
                    component: businessViewContract,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: 'businessReceiveContract',
                    name: 'businessReceiveContract',
                    component: businessReceiveContract,
                },
                {
                    path: 'businessMaintainContract',
                    name: 'businessMaintainContract',
                    component: businessMaintainContract,
                },
                {
                    path: 'marketViewContract',
                    name: 'marketViewContract',
                    component: marketViewContract,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: 'marketAllproject',
                    name: 'marketAllproject',
                    component: marketAllproject,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: 'viewProject',
                    name: 'viewProject',
                    component: viewProject,
                },
                {
                    path: 'marketTBSignedproject',
                    name: 'marketTBSignedproject',
                    component: marketTBSignedproject,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: 'marketExpireproject',
                    name: 'marketExpireproject',
                    component: marketExpireproject,
                },
                {
                    path: 'financialDataListM',
                    name: 'financialDataListM',
                    component: financialDataListM,
                },
                {
                    path: 'financialDataDetails',
                    name: 'financialDataDetails',
                    component: financialDataDetails,
                },
                {
                    path: 'financialDataEditM',
                    name: 'financialDataEditM',
                    component: financialDataEditM,
                },
                {
                    path: 'financialDataEditF',
                    name: 'financialDataEditF',
                    component: financialDataEditF,
                },
                {
                    path: 'financialDataListF',
                    name: 'financialDataListF',
                    component: financialDataListF,
                },
                {
                    path: 'inExecutionProject',
                    name: 'inExecutionProject',
                    component: inExecutionProject,
                },
                {
                    path: 'businessAllproject',
                    name: 'businessAllproject',
                    component: businessAllproject,
                },
                {
                    path: 'businessTBSignedproject',
                    name: 'businessTBSignedproject',
                    component: businessTBSignedproject,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: 'businessExpireproject',
                    name: 'businessExpireproject',
                    component: businessExpireproject,
                },
                {
                    path: 'clueUpdate',
                    name: 'clueUpdate',
                    component: clueUpdate,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: "myConcern",
                    name: "myConcern",
                    component: myConcern,
                    meta: {
                        keepAlive: true, //此组件需要被缓存
                    }
                },
                {
                    path: "accountManage",
                    name: "accountManage",
                    component: accountManage
                },
                {
                    path: "departmentManage",
                    name: "departmentManage",
                    component: departmentManage
                },
                {
                    path: "clueView/addClue",
                    name: "addClue",
                    component: addClue
                },
                {
                    path: "marketCreateContract/addContract",
                    name: "addContract",
                    component: addContract
                },
                {
                    path: "marketViewContract/createdRelatednessContract",
                    name: "createdRelatednessContract",
                    component: createdRelatednessContract
                },
                {
                    path: "marketCreateContract/dealExpireContract",
                    name: "dealExpireContract",
                    component: dealExpireContract
                },
                {
                    path: "businessMaintainContract/maintainContract",
                    name: "maintainContract",
                    component: maintainContract
                },
                {
                    path: "marketViewContract/viewContract",
                    name: "viewContract",
                    component: viewContract
                },
                {
                    path: "businessReceiveContract/receiveContract",
                    name: "receiveContract",
                    component: receiveContract
                },
                {
                    path: "clueView/clueViewDetail",
                    name: "clueViewDetail",
                    component: clueViewDetail
                },
                {
                    path: "clueView/clueViewUpdate",
                    name: "clueViewUpdate",
                    component: clueViewUpdate
                },
                {
                    path: "clueUpdate/deitOne",
                    name: "deitOne",
                    component: deitOne
                },
                {
                    path: "clueUpdate/examineDetail",
                    name: "examineDetail",
                    component: examineDetail
                },
                {
                    path: "clueUpdate/examineDetail2",
                    name: "examineDetail2",
                    component: examineDetail2
                },
                {
                    path: "clueUpdate/deitTwo",
                    name: "deitTwo",
                    component: deitTwo
                },
                {
                    path: "clueUpdate/deitThree",
                    name: "deitThree",
                    component: deitThree
                },
                {
                    path: "clueUpdate/deitFour",
                    name: "deitFour",
                    component: deitFour
                },
                {
                    path: "clueUpdate/deitFive",
                    name: "deitFive",
                    component: deitFive
                },
                {
                    path: "clueUpdate/deitSix",
                    name: "deitSix",
                    component: deitSix
                },
                {
                    path: "clueUpdate/deitSeven",
                    name: "deitSeven",
                    component: deitSeven
                },
                {
                    path: "swOtherUpdate",
                    name: "swOtherUpdate",
                    component: swOtherUpdate,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: "clueUpdateT",
                    name: "clueUpdateT",
                    component: clueUpdateT,
                    // meta: {
                    //     keepAlive: true
                    // }
                },
                {
                    path: "swDirectorUpdate",
                    name: "swDirectorUpdate",
                    component: swDirectorUpdate
                },
                {
                    path: "mOtherUpdate",
                    name: "mOtherUpdate",
                    component: mOtherUpdate
                },
                {
                    path: "customer",
                    name: "customer",
                    component: customer,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: "customerEditPage",
                    name: "customerEditPage",
                    component: customerEditPage
                },
                {
                    path: "viewCustomer",
                    name: "viewCustomer",
                    component: viewCustomer
                },
                {
                    path: "contacts",
                    name: "contacts",
                    component: contacts
                },
                {
                    path: "/contacts/contactEditor",
                    name: "contactEditor",
                    component: contactEditor
                }, {
                    path: "task",
                    name: "task",
                    component: task
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/loginThirdParty',
            name: 'loginThirdParty',
            component: loginThirdParty
        },
        {
            path: '*',
            redirect: {
                name: 'login'
            }
        }
    ]

})


// WEBPACK FOOTER //
// ./src/router/index.js